import { createTheme, alpha, responsiveFontSizes } from "@mui/material/styles";
import baseTheme from "assets/theme";

/**
 * Mobile-only theme (used under /m/*).
 * Mobile-only operating theme: compact spacing, restrained surfaces,
 * small strategic radius, and native-feeling controls.
 */
export const mobileTheme = responsiveFontSizes(
  createTheme(baseTheme, {
    palette: {
      background: {
        default: "#F7F8FA",
        paper: "#FFFFFF",
      },
      // Keep baseTheme's custom palette extensions used by MD* components,
      // but tighten text contrast for mobile.
      text: {
        primary: "#0F0F12",
        secondary: alpha("#0F0F12", 0.64),
      },
      divider: alpha("#000000", 0.07),
    },
    shape: {
      borderRadius: 8,
    },
    typography: {
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
      h4: { fontWeight: 800, letterSpacing: 0, lineHeight: 1.08 },
      h5: { fontWeight: 800, letterSpacing: 0, lineHeight: 1.12 },
      h6: { fontWeight: 850, letterSpacing: 0 },
      subtitle1: { fontWeight: 800 },
      subtitle2: { fontWeight: 800 },
      button: { textTransform: "none", fontWeight: 800 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: 16,
            lineHeight: 1.4,
            WebkitTextSizeAdjust: "100%",
            backgroundColor: "#F7F8FA",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            border: `1px solid ${alpha("#0F0F12", 0.09)}`,
            boxShadow: "none",
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true,
          size: "small",
        },
        styleOverrides: {
          root: {
            minHeight: 43,
            borderRadius: 8,
            paddingLeft: 15,
            paddingRight: 15,
            fontSize: "0.9rem",
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            height: 24,
            borderRadius: 999,
            fontWeight: 800,
          },
          label: {
            fontSize: "0.74rem",
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          size: "small",
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            backgroundColor: "#FFFFFF",
          },
          input: {
            paddingTop: 10,
            paddingBottom: 10,
            fontSize: "0.94rem",
          },
        },
      },
      MuiBottomNavigation: {
        styleOverrides: {
          root: {
            backgroundColor: alpha("#FFFFFF", 0.92),
            backdropFilter: "blur(10px)",
          },
        },
      },
    },
  })
);
